import { render } from "./Addition_bottom.vue?vue&type=template&id=24e5eeb7"
import script from "./Addition_bottom.vue?vue&type=script&lang=js"
export * from "./Addition_bottom.vue?vue&type=script&lang=js"

import "./Addition_bottom.vue?vue&type=style&index=0&id=24e5eeb7&lang=css"

import exportComponent from "/Users/news/Desktop/source/topic_freddy/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])